import axios from "axios";

export default {
    methods: {
        verificarEmailCadastrado(email) {
            axios
                .get(`${this.url_base.rota_api}/usuario/verifica-email-existente/?nm_email=${email}`)
                .then(response => {
                    this.email_verificado = response.data
                    if (this.email_verificado !== false) {
                        this.proximo = false
                        this.verifica_email = true
                    }
                })
                .catch(error => {
                    this.mensagem(
                        'error',
                        `Tipo do erro: ${error.message}, Falha ao tentar cadastrar email, caso não consiga reinicia a página.`,
                        null,
                        false)
                })
            this.verifica_email = false
        }
    }
}